import { toast } from "react-toastify";

const QuantitySelector = ({ quantity, setQuantity, maxStock, disabled }) => {
  const increaseQuantity = () => {
    if (quantity < maxStock) {
      setQuantity((prev) => prev + 1);
    } else {
      toast.info(`Maximum available quantity is ${maxStock}`);
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) setQuantity((prev) => prev - 1);
  };

  const minusOff = quantity <= 1 || disabled;
  const plusOff = quantity >= maxStock || disabled;

  return (
    <div className="inline-flex items-center rounded-md border border-gray-300 overflow-hidden bg-white">
      <button
        type="button"
        onClick={decreaseQuantity}
        disabled={minusOff}
        aria-label="Decrease quantity"
        className={`w-9 h-9 flex items-center justify-center text-lg ${minusOff ? "text-gray-300 cursor-not-allowed" : "text-yellow-800 hover:bg-yellow-50"
          }`}
      >
        −
      </button>
      <div className="w-11 h-9 flex items-center justify-center border-x border-gray-300 text-sm font-medium text-gray-800">
        {disabled ? (
          <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-yellow-800" />
        ) : (
          quantity
        )}
      </div>
      <button
        type="button"
        onClick={increaseQuantity}
        disabled={plusOff}
        aria-label="Increase quantity"
        className={`w-9 h-9 flex items-center justify-center text-lg ${plusOff ? "text-gray-300 cursor-not-allowed" : "text-yellow-800 hover:bg-yellow-50"
          }`}
      >
        +
      </button>
    </div>
  );
};

export default QuantitySelector;